import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Clock, ShieldCheck, ScrollText } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const PoliciesFaq = ({ property }) => {
  const { t } = useLang();
  const policies = property?.policies || {};
  const faqs = property?.faqs || [];
  const rules = policies.house_rules || [];

  return (
    <section id="faq" className="py-20 md:py-28 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14">
        <div>
          <p className="text-primary font-medium text-sm uppercase tracking-widest mb-2">{t("Good to know")}</p>
          <h2 className="font-script text-6xl md:text-8xl leading-tight text-foreground mb-8">
            {t("Policies & house rules")}
          </h2>

          <div className="space-y-4">
            <div className="flex items-start gap-4 bg-card rounded-xl p-5">
              <Clock className="h-6 w-6 text-secondary flex-shrink-0" strokeWidth={1.5} />
              <div>
                <div className="font-semibold text-foreground">{t("Check-in / Check-out")}</div>
                <div className="text-sm text-muted-foreground">{t("After")} {policies.check_in_time} · {t("Before")} {policies.check_out_time}</div>
              </div>
            </div>
            <div className="flex items-start gap-4 bg-card rounded-xl p-5">
              <ShieldCheck className="h-6 w-6 text-secondary flex-shrink-0" strokeWidth={1.5} />
              <div>
                <div className="font-semibold text-foreground">{t("Cancellation")}</div>
                <div className="text-sm text-muted-foreground">{t(policies.cancellation)}</div>
              </div>
            </div>
            <div className="flex items-start gap-4 bg-card rounded-xl p-5">
              <ScrollText className="h-6 w-6 text-secondary flex-shrink-0 mt-0.5" strokeWidth={1.5} />
              <div>
                <div className="font-semibold text-foreground mb-2">{t("House rules")}</div>
                <ul className="space-y-1.5">
                  {rules.map((r, i) => (
                    <li key={r || i} className="text-sm text-muted-foreground flex gap-2">
                      <span className="text-secondary">·</span> {t(r)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div>
          <p className="text-primary font-medium text-sm uppercase tracking-widest mb-2">{t("Questions")}</p>
          <h2 className="font-script text-6xl md:text-8xl leading-tight text-foreground mb-8">
            {t("Frequently asked")}
          </h2>
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.q || i}
                value={`faq-${i}`}
                data-testid={`faq-${i}`}
                className="bg-card rounded-xl border border-border px-5"
              >
                <AccordionTrigger className="text-left font-semibold text-foreground text-lg md:text-xl hover:no-underline">
                  {t(f.q)}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed">{t(f.a)}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
